'use client';

import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import {
  useBoolean,
  useCopyToClipboard,
  useDebounceCallback,
} from 'usehooks-ts';

import {
  HeartIcon,
  ProductAction,
  ShareNetworkIcon,
  SpinnerIcon,
} from '@/components';
import { useCheckAuthValue, useProductValue } from '@/context';
import { toggleFavoriteProduct } from '@/services';
import { cn } from '@/utils';

const ProductFavoriteAction = () => {
  const { id: productId, isFavorite: initialFavorite } = useProductValue();
  const { value: isFavorite, setValue: setFavorite } = useBoolean(
    Boolean(initialFavorite),
  );
  const { isPending, mutate } = useMutation({
    mutationFn: toggleFavoriteProduct,
    onSuccess: () => {
      setFavorite(prev => !prev);
    },
    onError: ({ message }) => {
      toast.error(message);
    },
  });

  return (
    <ProductAction
      title='افزودن به علاقه‌مندی‌ها'
      disabled={isPending}
      onClick={() => {
        if (productId) {
          mutate({ productId });
        }
      }}
    >
      {isPending ? (
        <SpinnerIcon className='animate-spin' />
      ) : (
        <HeartIcon
          weight={isFavorite ? 'fill' : undefined}
          className={cn(isFavorite && 'text-danger')}
        />
      )}
    </ProductAction>
  );
};

const ProductShareAction = () => {
  const [_, copy] = useCopyToClipboard();

  const handleShare = useDebounceCallback(async () => {
    copy(location.href)
      .then(() => {
        toast.info('آدرس با موفقیت کپی شد');
      })
      .catch(() => {
        toast.error('کپی کردن با خطا مواجه شد');
      });
  }, 300);

  return (
    <ProductAction title='اشتراک‌گذاری' onClick={handleShare}>
      <ShareNetworkIcon className='size-5' />
    </ProductAction>
  );
};

const ProductActions = () => {
  const { success } = useCheckAuthValue();

  return (
    <div className='absolute start-4 top-4 flex flex-col gap-2'>
      {success ? <ProductFavoriteAction /> : null}
      <ProductShareAction />
    </div>
  );
};

export { ProductActions, ProductFavoriteAction, ProductShareAction };
